import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { BsWhatsapp } from 'react-icons/bs';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/amit-talole-670031184/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/amit-talole" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://www.instagram.com/its_amit_talole_/" target="_blank" rel="noreferrer" ><FaInstagram /></a>
      <a href="https://wa.me/+919764569473" target="_blank" rel="noreferrer" ><BsWhatsapp /></a>
    </div>
  )
}

export default HeaderSocials